import React, { useEffect, useState } from 'react'

import Container from 'Components/shared/Container'
import Content from 'Components/shared/Content'

import ClientForm from 'Components/ClientForm'
import AppInformation from 'Components/AppInformation/New'
import WelcomeMessage from 'Components/WelcomeMessage'
import HomepageLinks from 'Components/HomepageLinks'
import MenuScreen from 'Components/MenuScreen'
import Resources from 'Components/Resources/New'
import CustomLinks from 'Components/CustomLinks/New'
import SaveButtons from 'Components/SaveButtons'
import { clubTemplate } from 'Constants'
import handleCreate from 'Helpers/create'
import { removeSelectedClub } from 'Store/clubs'

export default () => {
  const [club] = useState(clubTemplate)
  const [selectedClub, setSelectedClub] = useState(clubTemplate)
  const [previewImages, setPreviewImages] = useState({})
  const [links, setLinks] = useState([])
  const [alreadyCreated, setAlreadyCreated] = useState(false)

  useEffect(async () => {
    removeSelectedClub()
  }, [])

  function handleSaveAndQuit() {
    handleCreate(selectedClub, links, previewImages, alreadyCreated, setAlreadyCreated, true)
  }

  return (
    <>
      <Content>
        <ClientForm
          onSubmit={e => {
            e.preventDefault()
            handleCreate(selectedClub, links, previewImages, alreadyCreated, setAlreadyCreated)
          }}
        >
          <Container>
            <SaveButtons newClient handleSaveAndQuit={handleSaveAndQuit} />
            <AppInformation
              masterClub={club}
              club={selectedClub}
              setSelectedClub={setSelectedClub}
              previewImages={previewImages}
              setPreviewImages={setPreviewImages}
            />
            <WelcomeMessage
              masterClub={club}
              club={selectedClub}
              setSelectedClub={setSelectedClub}
            />
            <HomepageLinks
              masterClub={club}
              club={selectedClub}
              setSelectedClub={setSelectedClub}
            />
            <MenuScreen
              masterClub={club}
              club={selectedClub}
              setSelectedClub={setSelectedClub}
              previewImages={previewImages}
            />
            <Resources
              masterClub={club}
              club={selectedClub}
              setSelectedClub={setSelectedClub}
              previewImages={previewImages}
              setPreviewImages={setPreviewImages}
            />
            <CustomLinks
              club={selectedClub}
              masterClub={club}
              customLinks={links}
              setCustomLinks={setLinks}
            />
            <SaveButtons newClient handleSaveAndQuit={handleSaveAndQuit} />
          </Container>
        </ClientForm>
      </Content>
    </>
  )
}
